import { FloatingFormItem } from '@/components/_common';
import { usePurchaseCancel } from '@/core/domain/purchase/Purchase.hooks';
import { PurchaseCancelRequest } from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Modal, ModalProps, Row, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  purchaseId?: number;
  shouldProvideCancellationReasonInPurchase?: boolean;
};

interface FormValues {
  cancellationReason: string;
}

const PurchasesCancelModal: React.FC<Props> = ({
  purchaseId,
  shouldProvideCancellationReasonInPurchase,
  ...props
}: Props) => {
  const [form] = Form.useForm<FormValues>();

  const requiredField = useDefaultEmptyFieldError();

  const purchaseCancel = usePurchaseCancel();

  const handleSubmit = async () => {
    const { cancellationReason } = await form.validateFields();

    if (purchaseId) {
      const obj: PurchaseCancelRequest = {
        purchaseId,
        cancellationReason,
      };

      await purchaseCancel.mutateAsync(obj);
      props.onCancel();
    }
  };

  const handleCancel = async () => {
    form.resetFields();
    props.onCancel();
  };

  return (
    <Modal
      {...props}
      onOk={handleSubmit}
      onCancel={handleCancel}
      title="Cancelamento de compras"
      okText="Confirmar"
      width={500}
      confirmLoading={purchaseCancel.isLoading}
      okButtonProps={{ disabled: purchaseCancel.isLoading }}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Typography.Text>
              Deseja realmente cancelar a compra?
            </Typography.Text>
          </Col>

          {shouldProvideCancellationReasonInPurchase && (
            <Col span={24}>
              <FloatingFormItem
                label="Justificativa do cancelamento da compra"
                rules={[requiredField]}
                name="cancellationReason"
              >
                <TextArea rows={4} />
              </FloatingFormItem>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default PurchasesCancelModal;
